export default theme => ({
  gridContainer: {
    //marginBottom: 25,
    // padding: 10,
    // borderWidth: 1,
    // borderStyle: 'solid',
    // borderColor: 'rgba(0,0,0,0.4)',
    borderRadius: 5,
    // background: "white",
    // boxShadow: "1px 1px 10px #ddd"
  },
  gridItem: {
    padding: 5,
  },

  formContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    // marginTop: 30
    //padding: 15,
  },

  textLabelError: {
    color: 'red',
    fontWeight: 'bold',
    marginBottom: 0,
  },

  textLabelSuccess: {
    color: 'rgb(100,230,100)',
    marginBottom: 0,
  },
});
